import React from 'react';
import FormDialog, { DialogButton } from './FormDialog';

export default function ConfirmModal({
  open,
  onClose,
  onConfirm,
  title,
  message,
  confirmText = 'تأكيد',
  cancelText = 'إلغاء',
  loading,
  danger = false,
}) {
  return (
    <FormDialog
      open={open}
      onClose={loading ? () => {} : onClose}
      title={title || 'تأكيد'}
      subtitle={danger ? 'هذا الإجراء قد لا يمكن التراجع عنه' : undefined}
      icon={danger ? '⚠️' : '❓'}
      maxWidth={440}
      loading={loading}
      footer={(
        <>
          <DialogButton variant="ghost" onClick={onClose} disabled={loading}>{cancelText}</DialogButton>
          <DialogButton variant={danger ? 'danger' : 'primary'} onClick={onConfirm} loading={loading}>
            {confirmText}
          </DialogButton>
        </>
      )}
    >
      <p className="vi-confirm-message">{message}</p>
    </FormDialog>
  );
}